module.exports = __webpack_public_path__ + "static/media/sc36.39.3bf0ef17.mp4";